import React from 'react';
import DashboardView from 'routes/Dashboard/Dashboard.view';
import { useDashboardState } from './Dashboard.state';

const Dashboard: React.FC<{}> = () => {
    const state = useDashboardState();

    return (
        <DashboardView
            {...{
                ...state,
                ...{
                    selectedKey: state.tabKey || 'areas'
                }
            }}
        ></DashboardView>
    );
};

export default Dashboard;
